<template>
  <div class="w-full pr-3 text-gray-dark flex items-center justify-between">
    <span>{{ resolveSentence }}</span>
    <div class="flex items-center">
      <base-button variant="transparent"
                   icon="close"
                   icon-size="1.5rem"
                   class="flex items-center text-gray-dark"
                   id="cancel-button"
                   @click="$emit('update-mode', EXAMPLE_EDITOR_MODE.BULK)"
      />
      <busy-button v-if="isBulkMoveReady"
                   variant="transparent-primary"
                   icon="done"
                   icon-size="1.5rem"
                   class="flex items-center"
                   :id="intentMoveButtonId"
                   :is-loading="isBusy"
                   @click="$emit('move-examples')"
      >
        <span class="ml-2">Move</span>
      </busy-button>
    </div>
  </div>
</template>

<script>
import { EXAMPLE_EDITOR_MODE } from '@/store/constants'
import { BUSY_BUTTONS } from '@/utils/busy-buttons.constants'
import BusyButton from '@/components/common/BusyButton'
import busyButtonsModule from '@/store/modules/busy-buttons.module'

export default {
  name: 'IntentExamplesHeaderBulkMove',
  components: {
    BusyButton
  },
  props: {
    selectedExamplesCount: {
      type: Number
    },
    isBulkMoveReady: {
      type: Boolean
    }
  },
  data() {
    return {
      EXAMPLE_EDITOR_MODE,
      intentMoveButtonId: BUSY_BUTTONS.INTENT_MOVE
    }
  },
  computed: {
    isBusy() {
      return busyButtonsModule.isButtonBusy(this.intentMoveButtonId)
    },

    resolveSentence() {
      return this.isBulkMoveReady ?
        `Move ${this.selectedExamplesCount} ${this.selectedExamplesCount === 1 ? 'example' : 'examples'}?` :
        'Please select an Intent'
    }
  }
}
</script>
